import { Component, OnInit, Input, ViewEncapsulation, OnDestroy, signal } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { AppStateService } from "src/app/core-module/services/app-state.service";
import { map, Subject, takeUntil } from 'rxjs';

import { FormBuilder, FormGroup, FormArray, FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { ErrorComponent } from "src/app/error/error.component";
import { DataLayerService } from "src/app/core-module/services/data-layer.service";

import {environment} from "../../../../environments/environment";
import { AvailableFeaturesStateService } from "../../../core-module/services/state/available-features-state.service";
import { DimmingInterfaceStateService } from "../../../core-module/services/state/dimming-interface-state.service";
import { MultiOneHttpClient } from "../../../core-module/services/state/multi-one-http-client.service";
import { UiSignalsStateService } from "../../../core-module/services/state/ui-signals-state.service";
import { UserPreferencesStateService } from "../../../core-module/services/state/user-preferences-state.service";
import {
  FEATURE_LABEL_AOC_MULTI_CHANNEL,
  FEATURE_LABEL_CLO_LITE,
  FEATURE_LABEL_DSC,
  FEATURE_LABEL_LOW_MAINS_LOCK,
  FEATURE_LABEL_DYNA_DIMMER,
  FEATURE_LABEL_LINE_SWITCH,
  FEATURE_LABEL_MIN_DIM_LEVEL,
  FEATURE_LABEL_OTP,
  FEATURE_LABEL_STARTUP_TIME,
  FEATURE_LABEL_TOUCH_AND_DIM,
  FEATURE_LABEL_ZTV,
  FEATURE_SELECTION_CANONICAL_MAP,
} from "../../constants/feature-supported.constants";
@Component({
  standalone: false,
  selector: "app-selecting-device-modal",
  templateUrl: "./selecting-device-modal.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./selecting-device-modal.component.scss"],
})
export class SelectingDeviceModalComponent implements OnInit, OnDestroy {
  modalOptions: NgbModalOptions;

  @Input() public device;
  @Input() public selectedComparingDevices;
  @Input() public hasSuccessfulFeatures: boolean;
  devicePopup;
  selectedDevices;
  addColumn: string[] = [];
  columnSelection: FormGroup;
  isFeatureSelected;
  private readonly isSelectDisabledSignal = signal(false);
  storeFilterColumns;
  private readonly hide12ncSignal = signal(true);
  debounceTimeout: ReturnType<typeof setTimeout> | null = null;
  private readonly hideDeviceNameSignal = signal(true);
  private readonly hideDatasheetLinkSignal = signal(true);
  private readonly hideApplicationSignal = signal(true);
  private readonly hidePoutSignal = signal(true);
  private readonly hideIoutMinSignal = signal(true);
  private readonly hideIoutMaxSignal = signal(true);
  private readonly hideInterfaceSignal = signal(true);
  private readonly hideDimmingSignal = signal(true);
  private readonly hideEfficiencySignal = signal(true);
  private readonly hideIsolationSignal = signal(true);
  private readonly hideMountingSignal = signal(true);
  private readonly hideLengthSignal = signal(true);
  private readonly hideWidthSignal = signal(true);
  private readonly hideHeightSignal = signal(true);
  private readonly hideSimpleSetMultiDeviceConfigurationSignal = signal(true);
  private readonly hideVoutMinSignal = signal(true);
  private readonly hideVoutMaxSignal = signal(true);
  hideSelectAll;
  private readonly isDisbaleBtnSignal = signal(false);
  countColumns = 1;
  columnList = [
    "12nc",
    "deviceName",
    "datasheet",
    "applicationArea",
    "pOut",
    "iOutMin",
    "iOutMax",
    "vOutMax",
    "vOutMin",
    "configInterface",
    "dimming",
    "efficiency",
    "isolation",
    "moutning",
    "length",
    "width",
    "height",
    "SimpleSetBoxConfiguration",
  ];

  configurationData;
  softwareVersions = {};
  latestFirmware;
  multipleFirmwareVersions: string[] = [];

  device12nc;
  private readonly loadingSignal = signal(false);
  envHostName;
  preferencesAPI = "config/api/v1/preferences";
  fileName;
  fileContent;
  decryptData;
  isErrorPopup;
  uploadFeature;

  unsubscribe = new Subject<void>();

  envStartConfigURL;
  startConfigurationData = {};
  feature12NcName: string[] = [];
  envScehmaLIstApi: string;
  schemaResp: string[] = [];
  softwareVersionSchema: string;
  private normalizeSelectedFeatureValue(feature: string): string {
    const trimmedFeature = feature.trim();
    const normalizedFeature = trimmedFeature.toLowerCase();

    return FEATURE_SELECTION_CANONICAL_MAP[normalizedFeature] || trimmedFeature;
  }

  private appendSelectedFeature(selectedFeaturesInfo: string[], feature: string): void {
    const normalizedFeature = this.normalizeSelectedFeatureValue(feature);

    if (!selectedFeaturesInfo.includes(normalizedFeature)) {
      selectedFeaturesInfo.push(normalizedFeature);
    }
  }

  /**
   * If the CSV-style schema string `val` contains a comma-separated entry
   * matching `pattern`, append `featureLabel` to `selectedFeaturesInfo`
   * (skipped when `featureLabel` is null) and return the third `:`-separated
   * segment (the version schema). Returns `undefined` on no match so callers
   * can `?? this.xxx` to preserve the previous value.
   */
  private extractFeatureVersion(
    val: string,
    pattern: RegExp,
    featureLabel: string | null,
    selectedFeaturesInfo: string[]
  ): string | undefined {
    const match = val.match(pattern);
    if (!match) {
      return undefined;
    }
    if (featureLabel !== null) {
      this.appendSelectedFeature(selectedFeaturesInfo, featureLabel);
    }
    return match.toString().split(":")[2];
  }
  lumin0SoftwareVersionSchema: string;
  lumin3SoftwareVersionSchema: string;
  lumin4SoftwareVersionSchema: string;
  lumin5SoftwareVersionSchema: string;
  mtpSoftwareVersionSchema: string;
  dynadimmerSoftwareVersionSchema: string;
  dcemergencySoftwareVersionSchema: string;
  ampdimSoftwareVersionSchema: string;
  ztvSoftwareVersionSchema: string;
  ztvoutputSoftwareVersionSchema: string;
  lipSoftwareVersionSchema: string;

  get isSelectDisabled(): boolean { return this.isSelectDisabledSignal(); }
  set isSelectDisabled(value: boolean) { this.isSelectDisabledSignal.set(value); }

  get hide12nc(): boolean { return this.hide12ncSignal(); }
  set hide12nc(value: boolean) { this.hide12ncSignal.set(value); }

  get hideDeviceName(): boolean { return this.hideDeviceNameSignal(); }
  set hideDeviceName(value: boolean) { this.hideDeviceNameSignal.set(value); }

  get hideDatasheetLink(): boolean { return this.hideDatasheetLinkSignal(); }
  set hideDatasheetLink(value: boolean) { this.hideDatasheetLinkSignal.set(value); }

  get hideApplication(): boolean { return this.hideApplicationSignal(); }
  set hideApplication(value: boolean) { this.hideApplicationSignal.set(value); }

  get hidePout(): boolean { return this.hidePoutSignal(); }
  set hidePout(value: boolean) { this.hidePoutSignal.set(value); }

  get hideIoutMin(): boolean { return this.hideIoutMinSignal(); }
  set hideIoutMin(value: boolean) { this.hideIoutMinSignal.set(value); }

  get hideIoutMax(): boolean { return this.hideIoutMaxSignal(); }
  set hideIoutMax(value: boolean) { this.hideIoutMaxSignal.set(value); }

  get hideInterface(): boolean { return this.hideInterfaceSignal(); }
  set hideInterface(value: boolean) { this.hideInterfaceSignal.set(value); }

  get hideDimming(): boolean { return this.hideDimmingSignal(); }
  set hideDimming(value: boolean) { this.hideDimmingSignal.set(value); }

  get hideEfficiency(): boolean { return this.hideEfficiencySignal(); }
  set hideEfficiency(value: boolean) { this.hideEfficiencySignal.set(value); }

  get hideIsolation(): boolean { return this.hideIsolationSignal(); }
  set hideIsolation(value: boolean) { this.hideIsolationSignal.set(value); }

  get hideMounting(): boolean { return this.hideMountingSignal(); }
  set hideMounting(value: boolean) { this.hideMountingSignal.set(value); }

  get hideLength(): boolean { return this.hideLengthSignal(); }
  set hideLength(value: boolean) { this.hideLengthSignal.set(value); }

  get hideWidth(): boolean { return this.hideWidthSignal(); }
  set hideWidth(value: boolean) { this.hideWidthSignal.set(value); }

  get hideHeight(): boolean { return this.hideHeightSignal(); }
  set hideHeight(value: boolean) { this.hideHeightSignal.set(value); }

  get hideSimpleSetMultiDeviceConfiguration(): boolean { return this.hideSimpleSetMultiDeviceConfigurationSignal(); }
  set hideSimpleSetMultiDeviceConfiguration(value: boolean) { this.hideSimpleSetMultiDeviceConfigurationSignal.set(value); }

  get hideVoutMin(): boolean { return this.hideVoutMinSignal(); }
  set hideVoutMin(value: boolean) { this.hideVoutMinSignal.set(value); }

  get hideVoutMax(): boolean { return this.hideVoutMaxSignal(); }
  set hideVoutMax(value: boolean) { this.hideVoutMaxSignal.set(value); }

  get isDisbaleBtn(): boolean { return this.isDisbaleBtnSignal(); }
  set isDisbaleBtn(value: boolean) { this.isDisbaleBtnSignal.set(value); }

  get loading(): boolean { return this.loadingSignal(); }
  set loading(value: boolean) { this.loadingSignal.set(value); }
  rsoSoftwareVersionSchema: string;
  touchdimSoftwareVersionSchema: string;
  diia253maintenanceSoftwareVersionSchema: string;
  corridorSoftwareVersionSchema: string;
  aocSoftwareVersionSchema: string;
  astSoftwareVersionSchema: string;
  cloliteSoftwareVersionSchema: string;
  cloSoftwareVersionSchema: string;
  dimminginterfaceSoftwareVersionSchema: string;
  multiconfigSoftWareVersionSchema: string;
  lineswitchSoftwareVersionSchema: string;
  owpSoftwareVersionSchema: string;
  codedmainsSoftwareVersionSchema: string;
  dalipsuSoftwareVersionSchema: string;
  daliaddressing102SoftwareVersionSchema: string;
  oldDeviceName: string;
  newDeviceName: string;
  oldDevice: unknown;
  compatibleFeatures: string[];
  popup: string;
  storeConfigData: unknown;
  softwareVersion1: string;
  dtlSoftwareVersionSchema: string;
  flextuneSoftwareVersionSchema: string;
  mindimlevelSoftwareVersionSchema: string;
  dali102and207ConfigurationSoftwareVersionSchema: string;
  auxSoftwareVersionSchema: string;
  lsiSoftwareVersionSchema: string;
  aocmultichannelSoftwareVersionSchema: string;
  fwversion: string;
  otpSoftwareVersionSchema: string;
  dscSoftwareVersionSchema: string;
  lowmainslockSoftwareVersionSchema: string;

  constructor(

    public activeModal: NgbActiveModal,
    private readonly modalService: NgbModal,
    private readonly fb: FormBuilder,
    public route: Router,
    private readonly _dataLayerService: DataLayerService,
    private readonly appState: AppStateService,
    private readonly uiSignals: UiSignalsStateService,
    private readonly availFeat: AvailableFeaturesStateService,
    private readonly userPrefs: UserPreferencesStateService,
    private readonly httpClient: MultiOneHttpClient,
    private readonly dimmingInterfaceSvc: DimmingInterfaceStateService
  ) {}

  ngOnInit() {
    this.columnSelection = this.fb.group({
      filterColumns: this.fb.array([new FormControl('12nc')]),
    });
    this.envHostName = environment.multiOneAPIUrl;

    this.uiSignals.sendCloseSelectDevicePopup("");
    this.uiSignals.checkCloseSelectDevicePopup
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((resp) => {
        if (resp == "close") {
          this.activeModal.close();
        }
      });
    this.availFeat.getconfigData.subscribe((resp) => {
      this.devicePopup = resp;
    });

    this.uiSignals.getSelectedModal.subscribe((resp) => {
      this.popup = resp;
    });

    this.userPrefs.getValidation.subscribe((resp) => {
      if (resp === "success") {
        const tmp = [];
        this.uploadFeature = JSON.parse(
          this.appState.getImportFeatureData()
        );
        this.uploadFeature.successfulFeatures.forEach((element) => {
          if (element === "ALOMin") {
            const index =
              this.uploadFeature.successfulFeatures.indexOf("ALOMin");
            if (index !== -1) {
              this.uploadFeature.successfulFeatures[index] = "ALO";
            }
          } else if (element === "Ztv") {
            const index = this.uploadFeature.successfulFeatures.indexOf("Ztv");
            if (index !== -1) {
              this.uploadFeature.successfulFeatures[index] = "0-10V / 1-10V";
            }
          } else if (element === "Ast") {
            const index = this.uploadFeature.successfulFeatures.indexOf("Ast");
            if (index !== -1) {
              this.uploadFeature.successfulFeatures[index] = "Startup time";
            }
          } else if (element === "LumInfoFormat") {
            const index =
              this.uploadFeature.successfulFeatures.indexOf("LumInfoFormat");
            if (index !== -1) {
              this.uploadFeature.successfulFeatures[index] = "Luminaire info";
            }
          } else if (element === "CLOLite") {
            const index =
              this.uploadFeature.successfulFeatures.indexOf("CLOLite");
            if (index !== -1) {
              this.uploadFeature.successfulFeatures[index] = "CLO";
            }
          } else if (element === "SrPsu") {
            const index =
              this.uploadFeature.successfulFeatures.indexOf("SrPsu");
            if (index !== -1) {
              this.uploadFeature.successfulFeatures[index] = "SR PSU";
            }
          }
        });
        this.uploadFeature.successfulFeatures =
          this.uploadFeature.successfulFeatures.sort();
        this.isErrorPopup = true;
      } else {
        this.isErrorPopup = false;
      }
    });
    const savedFileName = this.appState.getSaveFileName();
    if (savedFileName) {
      this.fileName = savedFileName;
    }
    const savedDecryptData = this.appState.getDecryptData();
    if (savedDecryptData) {
      this.decryptData = savedDecryptData;
      if (this.decryptData.deviceSoftwareVersion.length > 3) {
        this.decryptData.deviceSoftwareVersion =
          this.decryptData.deviceSoftwareVersion.slice(0, -2);
      }
    }
    const savedFileContent = this.appState.getSaveFileContent();
    if (savedFileContent) {
      this.fileContent = savedFileContent;
    }
    const storedDevice12nc = this.appState.getDevice12nc();
    if (storedDevice12nc) {
      this.device12nc = storedDevice12nc;
    } else {
      if (this.device) {
        this.device12nc = this.device["device12nc"];
      }
    }

    // Edit Device functionality removed - this code now always runs
    this.loading = true;
    this.getDeviceSoftwareVersion(this.device12nc).subscribe(
      (deviceVersion) => {
        let versions = [];

        for (let i = 0; i < deviceVersion["items"].length; i++) {
          const devVersion = deviceVersion['items'][i].deviceType.nameAndVersion.split(":")[2];
          const itemversions = deviceVersion['items'][i].softwareVersions.map(ver =>
            {
              const version = ver.split(".").slice(0,2).join(".");
              return {
                version,
                selected: false,
                devVersion
              }
            });
            versions = [...versions, ...itemversions]
        }

        //Removing duplicates from the list
        versions = versions.filter((item, index, self) =>
          index === self.findIndex((t) => t.version === item.version)
        );

        if(versions.length > 0) {
          versions[0].selected = true;
          this.latestFirmware = versions[0].version;
          this.appState.setCompareFirmwareNoLatest(this.latestFirmware);
        }
        this.softwareVersions[this.device12nc] = {
          versions: versions
        }
        this.loading = false;
      }
    );

    this.loading = true;
    if (this.selectedComparingDevices) {
          if (this.selectedComparingDevices.length !== 0) {
            this.selectedComparingDevices.forEach((individualDevice) => {
              this.device12nc = individualDevice.device12nc;
              this.getDeviceSoftwareVersion(this.device12nc).subscribe(
                (deviceVersion) => {
                  let versions = [];

                  for (let i = 0; i < deviceVersion["items"].length; i++) {
                    const devVersion = deviceVersion['items'][i].deviceType.nameAndVersion.split(":")[2];
                    const itemversions = deviceVersion['items'][i].softwareVersions.map(ver =>
                      {
                        const version = ver.split(".").slice(0,2).join(".");
                        return {
                          version,
                          selected: false,
                          devVersion
                        }
                      });
                      versions = [...versions, ...itemversions];

                  }

                  //Removing duplicates from the list
                  versions = versions.filter((item, index, self) =>
                    index === self.findIndex((t) => t.version === item.version)
                  );

                  if(versions.length > 0) {
                    versions[0].selected = true;
                    this.latestFirmware = versions[0].version;
                    this.appState.setCompareFirmwareNoLatest(this.latestFirmware);
                  }
                  this.softwareVersions[individualDevice.device12nc] = {
                    versions: versions,

                  }
                  this.loading=false;
                }
              );
            });
          }
    }

    if (this.device) {
      const domain = "https://www.api.easydesignintool.signify.com";
      this.device.devicetypePicture = this.device.devicetypePicture
        ? this.device.devicetypePicture
        : this.device.picture;
      if (this.device.devicetypePicture !== undefined) {
        this.device.devicetypePicture =
          domain + this.device.devicetypePicture.replace(domain, "");
      }
    }

    let apiStoreColumnsData;
    this.userPrefs.getColumnSelection.subscribe((data) => {
      apiStoreColumnsData = data;
    });

    if (!apiStoreColumnsData) {
      const storeColumn = this.appState.getStoreColumn();
      if (storeColumn) {
        const storageData = storeColumn;
        apiStoreColumnsData = storageData["storeColumn"];
        const obj = {};
        if (!storageData["storeColumnsCheck"]) {
          apiStoreColumnsData = this.columnList;
        }
        obj["storeColumnsData"] = apiStoreColumnsData;
        obj["storeColumnsCheck"] = storageData["storeColumnsCheck"];
        this.appState.setStoreColumn(obj);
      }
    }

    if (apiStoreColumnsData) {
      this.hideDeviceName = false;
      this.hide12nc = false;
      this.hideDatasheetLink = false;
      this.hideApplication = false;
      this.hidePout = false;
      this.hideIoutMin = false;
      this.hideIoutMax = false;
      this.hideVoutMin = false;
      this.hideVoutMax = false;
      this.hideInterface = false;
      this.hideDimming = false;
      this.hideEfficiency = false;
      this.hideIsolation = false;
      this.hideMounting = false;
      this.hideLength = false;
      this.hideWidth = false;
      this.hideHeight = false;
      this.hideSimpleSetMultiDeviceConfiguration = false;
      this.storeFilterColumns = apiStoreColumnsData;
      let count = 0;
      this.storeFilterColumns.filter((data) => {
        count = count + 1;

        if (data === "12nc") {
          this.hide12nc = true;
        }
        if (data === "deviceName") {
          this.hideDeviceName = true;
        }
        if (data === "datasheet") {
          this.hideDatasheetLink = true;
        }
        if (data === "applicationArea") {
          this.hideApplication = true;
        }
        if (data === "pOut") {
          this.hidePout = true;
        }
        if (data === "iOutMin") {
          this.hideIoutMin = true;
        }
        if (data === "iOutMax") {
          this.hideIoutMax = true;
        }
        if (data === "vOutMax") {
          this.hideVoutMax = true;
        }
        if (data === "vOutMin") {
          this.hideVoutMin = true;
        }
        if (data === "configInterface") {
          this.hideInterface = true;
        }
        if (data === "dimming") {
          this.hideDimming = true;
        }
        if (data === "efficiency") {
          this.hideEfficiency = true;
        }
        if (data === "isolation") {
          this.hideIsolation = true;
        }
        if (data === "moutning") {
          this.hideMounting = true;
        }
        if (data === "length") {
          this.hideLength = true;
        }
        if (data === "width") {
          this.hideWidth = true;
        }
        if (data === "height") {
          this.hideHeight = true;
        }
        if (data === "SimpleSetBoxConfiguration") {
          this.hideSimpleSetMultiDeviceConfiguration = true;
        }
        this.selectColumn(data, true);
        if (count == 18) {
          this.hideSelectAll = true;
        } else {
          this.hideSelectAll = false;
        }
      });
    } else {
      this.selectAll(true);
    }
    // this.hideSelectAll = true;
    this.isFeatureSelected = this.columnSelection.value.filterColumns.length;
  }


  selectVersion( version, nc12){
    this.softwareVersions[nc12].versions.forEach(ver => {
      ver.selected = ver.version == version;
      if(ver.selected) {
        this.latestFirmware = version;
        this.appState.setCompareFirmwareNoLatest(this.latestFirmware);
      }
    });
  }

  configDevice() {
    if (this.debounceTimeout || this.isSelectDisabled) {
      return;
    }
    this.isSelectDisabled = true;
    this.debounceTimeout = setTimeout(() => {
      this.debounceTimeout = null;
      this.isSelectDisabled = false;
    }, 2000);

    this.buildConfigurtaionDataObj(this.device);
    const data = this.appState.getReaderDeviceFullInfo();
    // let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    // var decodedObj: LegacyAny = jwt_decode(JSON.stringify(currentUser));
    // this._dataLayerService.logUserDetails({
    //   UserId: localStorage.getItem("UserId"),
    //   companyId: decodedObj.company["companyId"],
    //   companyName: decodedObj.company["companyName"],
    //   userRole: decodedObj.role,
    // });
    this._dataLayerService.resetSetSelectedDeviceInfo();
    this._dataLayerService.setSelectedDeviceInfo({
      productName: data[0].deviceName,
      "12NC": data[0].device12nc,
      familyTopLevel: data[0].family,
      firmwareno: this.latestFirmware,
    });
  }

  selectingDevice(selectedDevice,option?) {
    if (this.debounceTimeout || this.isSelectDisabled) {
      return;
    }
    this.isSelectDisabled = true;
    this.debounceTimeout = setTimeout(() => {
      this.debounceTimeout = null;
      this.isSelectDisabled = false;
    }, 3000);

    this.loading = true;
    this.appState.removeDevice12nc();
    this.selectedDevices = selectedDevice;
    const storeConfigMode = this.appState.getStoreConfigMode();
    const storeOmitOption = this.appState.getStoreOmitOption();
    const exportedFeatureFile = this.appState.getExportedFeatureFile();
    // && (storeOmitOption && storeOmitOption['storeDevicePopupValue'] == "omit" && storeOmitOption['storeDevicePopupCheck'] == true)) {
    this.feature12NcName = [];
    this.buildConfigurtaionDataObj(this.selectedDevices);
  }

  selectColumn(tableName, e) {
    if (e) {
      if (tableName === "12nc") {
        this.hide12nc = true;
      }
      if (tableName === "deviceName") {
        this.hideDeviceName = true;
      }
      if (tableName === "datasheet") {
        this.hideDatasheetLink = true;
      }
      if (tableName === "applicationArea") {
        this.hideApplication = true;
      }
      if (tableName === "pOut") {
        this.hidePout = true;
      }
      if (tableName === "iOutMin") {
        this.hideIoutMin = true;
      }
      if (tableName === "iOutMax") {
        this.hideIoutMax = true;
      }
      if (tableName === "vOutMax") {
        this.hideVoutMax = true;
      }
      if (tableName === "vOutMin") {
        this.hideVoutMin = true;
      }
      if (tableName === "configInterface") {
        this.hideInterface = true;
      }
      if (tableName === "dimming") {
        this.hideDimming = true;
      }
      if (tableName === "efficiency") {
        this.hideEfficiency = true;
      }
      if (tableName === "isolation") {
        this.hideIsolation = true;
      }
      if (tableName === "moutning") {
        this.hideMounting = true;
      }
      if (tableName === "length") {
        this.hideLength = true;
      }
      if (tableName === "width") {
        this.hideWidth = true;
      }
      if (tableName === "height") {
        this.hideHeight = true;
      }
      if (tableName === "SimpleSetBoxConfiguration") {
        this.hideSimpleSetMultiDeviceConfiguration = true;
      }
    } else {
      if (tableName === "12nc") {
        this.hide12nc = false;
      }
      if (tableName === "deviceName") {
        this.hideDeviceName = false;
      }
      if (tableName === "datasheet") {
        this.hideDatasheetLink = false;
      }
      if (tableName === "applicationArea") {
        this.hideApplication = false;
      }
      if (tableName === "pOut") {
        this.hidePout = false;
      }
      if (tableName === "iOutMin") {
        this.hideIoutMin = false;
      }
      if (tableName === "iOutMax") {
        this.hideIoutMax = false;
      }
      if (tableName === "vOutMax") {
        this.hideVoutMax = false;
      }
      if (tableName === "vOutMin") {
        this.hideVoutMin = false;
      }
      if (tableName === "configInterface") {
        this.hideInterface = false;
      }
      if (tableName === "dimming") {
        this.hideDimming = false;
      }
      if (tableName === "efficiency") {
        this.hideEfficiency = false;
      }
      if (tableName === "isolation") {
        this.hideIsolation = false;
      }
      if (tableName === "moutning") {
        this.hideMounting = false;
      }
      if (tableName === "length") {
        this.hideLength = false;
      }
      if (tableName === "width") {
        this.hideWidth = false;
      }
      if (tableName === "height") {
        this.hideHeight = false;
      }
      if (tableName === "SimpleSetBoxConfiguration"){
        this.hideSimpleSetMultiDeviceConfiguration = false;
      }

    }
    const selectedColumnArray = <FormArray>(
      this.columnSelection.controls.filterColumns
    );
    if (e) {
      // 12nc is pre-seeded; skip duplicate push
      const alreadyAdded = selectedColumnArray.controls.some(c => c.value === tableName);
      if (!alreadyAdded) {
        selectedColumnArray.push(new FormControl(tableName));
      }
      if (selectedColumnArray.length == 18) {
        this.hideSelectAll = true;
      }
      this.countColumns = selectedColumnArray.length;
    } else {
      const index = selectedColumnArray.controls.findIndex(
        (x) => x.value === tableName
      );
      if (index !== -1) {
        selectedColumnArray.removeAt(index);
      }
      this.hideSelectAll = false;
      this.countColumns = selectedColumnArray.length;
    }
    if (selectedColumnArray.length < 1) {
      this.isDisbaleBtn = true;
    } else {
      this.isDisbaleBtn = false;
    }
    this.isFeatureSelected = this.columnSelection.value.filterColumns.length;
  }

  selectAll(e) {
    this.columnSelection = this.fb.group({
      filterColumns: this.fb.array([new FormControl('12nc')]),
    });
    if (e) {
      this.hideSelectAll = true;
      this.columnList.forEach((element) => {
        this.selectColumn(element, true);
      });
    } else {
      this.hideSelectAll = false;
      this.countColumns = 1;
      this.isDisbaleBtn = false;
      this.columnList.forEach((element) => {
        if (element !== '12nc') {
          this.selectColumn(element, false);
        }
      });
    }
  }

  onSubmit() {
    const tmp = [];
    for (let i = 0; i < this.columnSelection.value.filterColumns.length; i++) {
      if (tmp.indexOf(this.columnSelection.value.filterColumns[i]) === -1) {
        tmp.push(this.columnSelection.value.filterColumns[i]);
      }
    }
    // 12nc must always be present
    if (!tmp.includes('12nc')) {
      tmp.unshift('12nc');
    }
    this.addColumn = tmp;
    ///to change array order
    const reference_object = {};
    for (let i = 0; i < this.columnList.length; i++) {
      reference_object[this.columnList[i]] = i;
    }
    if (this.columnList.length > 0) {
      this.addColumn.sort(function (a, b) {
        ///to change array order
        return reference_object[a] - reference_object[b];
      });
    }

    // localStorage.setItem('storeColumn', JSON.stringify(this.addColumn));
    const storeColumn = this.appState.getStoreColumn() || {};
    const sortingObjectKey = new Object();
    sortingObjectKey["storeColumnsData"] = this.addColumn;
    if (storeColumn && storeColumn["storeColumnsCheck"]) {
      sortingObjectKey["storeColumnsCheck"] = storeColumn["storeColumnsCheck"];
    } else {
      sortingObjectKey["storeColumnsCheck"] = false;
    }
    this.appState.setStoreColumn(sortingObjectKey);
    this.httpClient.postCallForUserPreferences();
    this.userPrefs.setColumn(sortingObjectKey["storeColumnsData"]);
    this.activeModal.close();
    this.route.navigate(["/deviceList"]);
  }

  getDeviceSoftwareVersion(device12Nc) {
    return this.httpClient.getDeviceSoftwareVersion(this.envHostName, device12Nc);
  }

  buildConfigurtaionDataObj(deviceArg) {
    // this.service.getEnvValue();
    // // setTimeout( () => {
    // this.service.getEnvData
    //   .pipe(takeUntil(this.unsubscribe))
    //   .subscribe((url) => {
    //     if (url.length) {
    //       this.loading = true;
    //       this.unsubscribe.next(undefined);
          //this.envHostName = this.url;
          this.latestFirmware = this.appState.getCompareFirmwareNoLatest();
          this.envScehmaLIstApi = this.envHostName;
          const selectedVersion = this.softwareVersions[deviceArg.device12nc].versions.find(ver => ver.selected);
          // Use device-specific version instead of shared this.latestFirmware to avoid race conditions
          const deviceSpecificFirmware = selectedVersion.version;
          this.schemalistApi(
            deviceArg.device12nc,
            selectedVersion.devVersion
          ).subscribe((resp) => {
            const unSupportedFeatCheck = resp["metadata"].schemas;
            const tags = resp["metadata"].tags;
            if(tags && tags.length > 0){
              this.appState.setTags(tags[0]);
            }else{
              this.appState.setTags(null);
            }
            const supportedSchema: string[] = [];
            for (
              let index = 0;
              index < unSupportedFeatCheck.length;
              index++
            ) {
              const element = unSupportedFeatCheck[index];
              // if (
              //   !(element.includes("dynadimmer")
              //   || element.includes("lineswitch")
              //   || element.includes("codedmains")
              //   || element.includes("ampdim")
              //   || element.includes("dimminginterface")
              //   || element.includes("owp")
              // )) {
              supportedSchema.push(element);
              //}
            } //MOWEB 1.1.3 Release - Temp Update
            resp["metadata"].schemas = supportedSchema;
            if (resp["metadata"].schemas.length) {
              this.schemaResp = resp["metadata"].schemas;

              this.schemaResp.forEach((element, index) => {
                const birth =
                  element.match(/[^,]*mcsa-[^,]*/g) ||
                  element.match(/[^,]*birth-[^,]*/g) ||
                  element.match(/[^,]*public-[^,]*/g) ||
                  element.match(/[^,]*bl[^,]*/g) ||
                  element.match(/[^,]*''[^,]*/g);
                if (!birth) {
                  const splitted = element.split(":")[1];
                  if (splitted) {
                    const feature12NCvalue = splitted.substring(
                      0,
                      splitted.length - deviceArg.device12nc.length
                    );
                    this.feature12NcName.push(feature12NCvalue);
                  }
                }
              });
              this.feature12NcName = this.feature12NcName.filter(Boolean);
              this.feature12NcName.forEach((element) => {
                //if(element === 'owp-' || element === 'dynadimmer-' || element === 'lineswitch-') {
                // if (element === "owp-") {
                //   this.feature12NcName.splice(
                //     this.feature12NcName.indexOf(element),
                //     1
                //   );
                // }
              });
              const val = this.schemaResp.toString();
              const versiontoString =
                val.match(/[^,]*alo[^,]*/g) ||
                val.match(/[^,]*clo[^,]*/g) ||
                val.match(/[^,]*aoc[^,]*/g) ||
                val.match(/[^,]*ztv[^,]*/g) ||
                val.match(/[^,]*ast[^,]*/g) ||
                val.match(/[^,]*luminfoformat0[^,]*/g) ||
                val.match(/[^,]*luminfoformat3[^,]*/g) ||
                val.match(/[^,]*dalipsu[^,]*/g) ||
                val.match(/[^,]*daliaddressing102[^,]*/g)||
                val.match(/[^,]*daliconfiguration102and207[^,]*/g) ||
                val.match(/[^,]*aux[^,]*/g) ||
                val.match(/[^,]*lsi[^,]*/g) ||
                val.match(/[^,]*aocmultichannel[^,]*/g) ||
                val.match(/[^,]*otp[^,]*/g)
                this.softwareVersionSchema = versiontoString
                  .toString()
                  .split(":")[2];
              const selectedFeaturesInfo = [];
              //  selectedFeaturesInfo.push('0-10v / 1-10v', 'Alo', 'Aoc', 'Clo', 'CloLite', 'Startup time', 'Ztv');

              this.daliaddressing102SoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*daliaddressing102[^,]*/g, "Dali102Addressing", selectedFeaturesInfo
              ) ?? this.daliaddressing102SoftwareVersionSchema;

              this.dali102and207ConfigurationSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*daliconfiguration102and207[^,]*/g, "Dali102and207Configuration", selectedFeaturesInfo
              ) ?? this.dali102and207ConfigurationSoftwareVersionSchema;
                this.auxSoftwareVersionSchema = this.extractFeatureVersion(
                  val, /[^,]*aux[^,]*/g, "aux", selectedFeaturesInfo
                ) ?? this.auxSoftwareVersionSchema;
                this.lsiSoftwareVersionSchema = this.extractFeatureVersion(
                  val, /[^,]*lsi[^,]*/g, "lsi", selectedFeaturesInfo
                ) ?? this.lsiSoftwareVersionSchema;

                this.aocmultichannelSoftwareVersionSchema = this.extractFeatureVersion(
                  val, /[^,]*aocmultichannel[^,]*/g, "aocmultichannel", selectedFeaturesInfo
                ) ?? this.aocmultichannelSoftwareVersionSchema;

              if (val.match(/[^,]*otp-[^,]*/g)) {
                selectedFeaturesInfo.push("otp");
                const otpVersionString = val.match(/[^,]*otp-[^,]*/g);
                this.otpSoftwareVersionSchema =
                  otpVersionString.toString().split(":")[2];
              }

              this.multiconfigSoftWareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*multiconfigmode[^,]*/g, "Multiconfig", selectedFeaturesInfo
              ) ?? this.multiconfigSoftWareVersionSchema;

              this.dscSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*dsc-[^,]*/g, FEATURE_LABEL_DSC, selectedFeaturesInfo
              ) ?? this.dscSoftwareVersionSchema;

              this.lowmainslockSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*lowmainslock-[^,]*/g, FEATURE_LABEL_LOW_MAINS_LOCK, selectedFeaturesInfo
              ) ?? this.lowmainslockSoftwareVersionSchema;

              if (val.match(/[^,]*alo[^,]*/g)) {
                this.appendSelectedFeature(selectedFeaturesInfo, "Alo");
              }
              if (val.match(/[^,]*clo-[^,]*/g)) {
                if (
                  val
                    .match(/[^,]*clo-[^,]*/g)
                    .toString()
                    .split(":")[1]
                    .slice(
                      0,
                      val
                        .match(/[^,]*clo-[^,]*/g)
                        .toString()
                        .split(":")[1]
                        .indexOf(deviceArg.device12nc)
                    ) === "clo-"
                ) {
                  this.appendSelectedFeature(selectedFeaturesInfo, "Clo");
                  const cloversiontoString = val.match(/[^,]*clo-[^,]*/g);
                  this.cloSoftwareVersionSchema = cloversiontoString
                    .toString()
                    .split(":")[2];
                }
              }
              this.aocSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*aoc[^,]*/g, "Aoc", selectedFeaturesInfo
              ) ?? this.aocSoftwareVersionSchema;
              this.touchdimSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*touchdim[^,]*/g, "touchdim", selectedFeaturesInfo
              ) ?? this.touchdimSoftwareVersionSchema;
              this.diia253maintenanceSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*diia253maintenance[^,]*/g, "diia253maintenance", selectedFeaturesInfo
              ) ?? this.diia253maintenanceSoftwareVersionSchema;
              this.astSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*ast[^,]*/g, FEATURE_LABEL_STARTUP_TIME, selectedFeaturesInfo
              ) ?? this.astSoftwareVersionSchema;
              this.dimminginterfaceSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*dimminginterface[^,]*/g, "Dimminginterface", selectedFeaturesInfo
              ) ?? this.dimminginterfaceSoftwareVersionSchema;
              this.mtpSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*mtp[^,]*/g, "Mtp", selectedFeaturesInfo
              ) ?? this.mtpSoftwareVersionSchema;
              if (val.match(/[^,]*srpsu[^,]*/g)) {
                this.appendSelectedFeature(selectedFeaturesInfo, "SR PSU");
              }

              this.lumin0SoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*luminfoformat0[^,]*/g, null, selectedFeaturesInfo
              ) ?? this.lumin0SoftwareVersionSchema;

               this.lumin3SoftwareVersionSchema = this.extractFeatureVersion(
                 val, /[^,]*luminfoformat3[^,]*/g, null, selectedFeaturesInfo
               ) ?? this.lumin3SoftwareVersionSchema;

                  this.lumin4SoftwareVersionSchema = this.extractFeatureVersion(
                    val, /[^,]*luminfoformat4[^,]*/g, null, selectedFeaturesInfo
                  ) ?? this.lumin4SoftwareVersionSchema;


                   this.lumin5SoftwareVersionSchema = this.extractFeatureVersion(
                     val, /[^,]*luminfoformat5[^,]*/g, null, selectedFeaturesInfo
                   ) ?? this.lumin5SoftwareVersionSchema;
              this.ztvSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*ztv[^,]*/g, FEATURE_LABEL_ZTV, selectedFeaturesInfo
              ) ?? this.ztvSoftwareVersionSchema;
              this.ztvoutputSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*ztvoutput[^,]*/g, "ztvoutput", selectedFeaturesInfo
              ) ?? this.ztvoutputSoftwareVersionSchema;
              if (val.match(/[^,]*lip[^,]*/g)) {
                    this.appendSelectedFeature(selectedFeaturesInfo, "lip");
                const lipversiontoString = val.match(/[^,]*lip[^,]*/g);
                if (lipversiontoString.length > 1) {
                  this.lipSoftwareVersionSchema = lipversiontoString[1]
                    .toString()
                    .split(":")[2];
                } else {
                  this.lipSoftwareVersionSchema = lipversiontoString
                    .toString()
                    .split(":")[2];
                }
              }
              this.rsoSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*rso[^,]*/g, "rso", selectedFeaturesInfo
              ) ?? this.rsoSoftwareVersionSchema;
              this.cloliteSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*clolite[^,]*/g, FEATURE_LABEL_CLO_LITE, selectedFeaturesInfo
              ) ?? this.cloliteSoftwareVersionSchema;
              if (val.match(/[^,]*corridor-[^,]*/g)) {
                const corridorversiontoString =
                  val.match(/[^,]*corridor[^,]*/g);
                this.corridorSoftwareVersionSchema = corridorversiontoString
                  .toString()
                  .split(":")[2];
                this.appendSelectedFeature(selectedFeaturesInfo, "Corridor");
              }
              this.dcemergencySoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*dcemergency-[^,]*/g, "DC Emergency", selectedFeaturesInfo
              ) ?? this.dcemergencySoftwareVersionSchema;
              if (val.match(/[^,]*touchdim-[^,]*/g)) {
                const touchdimversiontoString =
                  val.match(/[^,]*touchdim[^,]*/g);
                this.touchdimSoftwareVersionSchema = touchdimversiontoString
                  .toString()
                  .split(":")[2];
                this.appendSelectedFeature(selectedFeaturesInfo, FEATURE_LABEL_TOUCH_AND_DIM);
              }
              if (val.match(/[^,]*diia253maintenance-[^,]*/g)) {
                const diia253maintenanceversiontoString = val.match(
                  /[^,]*diia253maintenance[^,]*/g
                );
                this.diia253maintenanceSoftwareVersionSchema =
                  diia253maintenanceversiontoString
                    .toString()
                    .split(":")[2];
                this.appendSelectedFeature(selectedFeaturesInfo, "diia253maintenance");
              }
              this.dynadimmerSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*dynadimmer-[^,]*/g, FEATURE_LABEL_DYNA_DIMMER, selectedFeaturesInfo
              ) ?? this.dynadimmerSoftwareVersionSchema;
              this.lineswitchSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*lineswitch-[^,]*/g, FEATURE_LABEL_LINE_SWITCH, selectedFeaturesInfo
              ) ?? this.lineswitchSoftwareVersionSchema;
              this.owpSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*owp-[^,]*/g, "Owp", selectedFeaturesInfo
              ) ?? this.owpSoftwareVersionSchema;
              this.codedmainsSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*codedmains-[^,]*/g, "Codedmains", selectedFeaturesInfo
              ) ?? this.codedmainsSoftwareVersionSchema;
              this.dalipsuSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*dalipsu-[^,]*/g, null, selectedFeaturesInfo
              ) ?? this.dalipsuSoftwareVersionSchema;
              this.daliaddressing102SoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*daliaddressing102-[^,]*/g, null, selectedFeaturesInfo
              ) ?? this.daliaddressing102SoftwareVersionSchema;
              this.dali102and207ConfigurationSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*daliconfiguration102and207-[^,]*/g, null, selectedFeaturesInfo
              ) ?? this.dali102and207ConfigurationSoftwareVersionSchema;
              if (val.match(/[^,]*aux-[^,]*/g)) {
                const auxVersionString = val.match(/[^,]*aux[^,]*/g);
                this.auxSoftwareVersionSchema =
                  auxVersionString.toString().split(":")[2];
                this.appendSelectedFeature(selectedFeaturesInfo, "aux");
              }
              this.lsiSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*lsi[^,]*/g, "lsi", selectedFeaturesInfo
              ) ?? this.lsiSoftwareVersionSchema;

              this.aocmultichannelSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*aocmultichannel[^,]*/g, FEATURE_LABEL_AOC_MULTI_CHANNEL, selectedFeaturesInfo
              ) ?? this.aocmultichannelSoftwareVersionSchema;

              this.otpSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*otp-[^,]*/g, FEATURE_LABEL_OTP, selectedFeaturesInfo
              ) ?? this.otpSoftwareVersionSchema;

              this.dscSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*dsc-[^,]*/g, FEATURE_LABEL_DSC, selectedFeaturesInfo
              ) ?? this.dscSoftwareVersionSchema;

              this.lowmainslockSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*lowmainslock-[^,]*/g, FEATURE_LABEL_LOW_MAINS_LOCK, selectedFeaturesInfo
              ) ?? this.lowmainslockSoftwareVersionSchema;

              if (val.match(/[^,]*ampdim-[^,]*/g)) {
                const ampdimVersiontoString = val.match(/[^,]*ampdim[^,]*/g);
                this.ampdimSoftwareVersionSchema = ampdimVersiontoString
                  .toString()
                  .split(":")[2];
                this.appendSelectedFeature(selectedFeaturesInfo, "Amp Dim");
              }
              this.dtlSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*dtl[^,]*/g, "DTL", selectedFeaturesInfo
              ) ?? this.dtlSoftwareVersionSchema;
              this.flextuneSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*flextune[^,]*/g, "Flextune", selectedFeaturesInfo
              ) ?? this.flextuneSoftwareVersionSchema;
              this.mindimlevelSoftwareVersionSchema = this.extractFeatureVersion(
                val, /[^,]*mindimlevel[^,]*/g, FEATURE_LABEL_MIN_DIM_LEVEL, selectedFeaturesInfo
              ) ?? this.mindimlevelSoftwareVersionSchema;
              // this.service.getEnvValue();
              // this.service.getEnvData
              //   .pipe(takeUntil(this.unsubscribe))
              //   .subscribe((url) => {
              //     if (url.length) {
              //       this.unsubscribe.next(undefined);
                    this.envStartConfigURL = this.envHostName;
                    // till demo purpose
                    let mockDevice = {};
                    // Use device-specific firmware version
                    let firmwareVersion = deviceSpecificFirmware;
                    if (firmwareVersion.length > 3) {
                      firmwareVersion = firmwareVersion.slice(
                        0,
                        -2
                      );
                    }
                    if (deviceArg.deviceName === "XH075C120V075KPF1") {
                      mockDevice = {
                        device12nc: deviceArg.device12nc,
                        softwareVersion: firmwareVersion,
                      };
                    } else {
                      mockDevice = {
                        device12nc: deviceArg.device12nc,
                        deviceName: deviceArg.deviceName,
                        softwareVersion: firmwareVersion,
                      };
                    }
                    this.httpClient
                      .getStartConfiguration(
                        mockDevice,
                        this.envStartConfigURL
                      )
                      .subscribe(
                        (data) => {
                          this.appState.removeDeviceVersion();
                          let configurationID;
                          if (this.appState.getConfigId()) {
                            configurationID =
                              this.appState.getConfigId();
                          } else {
                            configurationID = data["configurationID"];
                          }
                          const feature12Nc = [
                            ...new Set(this.feature12NcName),
                          ];
                          this.startConfigurationData["configurationID"] =
                            configurationID;
                          this.startConfigurationData["deviceName"] =
                            deviceArg["deviceName"];
                          this.startConfigurationData["softwareVersion"] =
                            deviceArg["softwareVersion"];
                          this.startConfigurationData["picture"] =
                            deviceArg["devicetypePicture"];
                          this.startConfigurationData["selectedFeaturesInfo"] = [];
                          this.startConfigurationData["luminSoftVer0"] =
                            this.lumin0SoftwareVersionSchema;
                          this.startConfigurationData["luminSoftVer3"] =
                            this.lumin3SoftwareVersionSchema;
                          this.startConfigurationData["luminSoftVer4"] =
                            this.lumin4SoftwareVersionSchema;
                          this.startConfigurationData["luminSoftVer5"] =
                            this.lumin5SoftwareVersionSchema;
                          this.startConfigurationData["dtlSoftVer"] =
                            this.dtlSoftwareVersionSchema;
                          this.startConfigurationData["flextuneSoftVer"] =
                            this.flextuneSoftwareVersionSchema;
                          this.startConfigurationData[
                            "mindimlevelSoftVer"
                          ] = this.mindimlevelSoftwareVersionSchema;
                          this.startConfigurationData["ztvSoftVer"] =
                            this.ztvSoftwareVersionSchema;
                          this.startConfigurationData["ztvoutputSoftVer"] =
                            this.ztvoutputSoftwareVersionSchema;
                          this.startConfigurationData["lipSoftVer"] =
                            this.lipSoftwareVersionSchema;
                          this.startConfigurationData["rsoSoftVer"] =
                            this.rsoSoftwareVersionSchema;
                          this.startConfigurationData["aocSoftVer"] =
                            this.aocSoftwareVersionSchema;
                          this.startConfigurationData["touchdimSoftVer"] =
                            this.touchdimSoftwareVersionSchema;
                          this.startConfigurationData[
                            "diia253maintenanceSoftVer"
                          ] = this.diia253maintenanceSoftwareVersionSchema;
                          this.startConfigurationData["corridorSoftVer"] =
                            this.corridorSoftwareVersionSchema;
                          this.startConfigurationData["astSoftVer"] =
                            this.astSoftwareVersionSchema;
                          this.startConfigurationData["cloliteSoftVer"] =
                            this.cloliteSoftwareVersionSchema;
                          this.startConfigurationData["cloSoftVer"] =
                            this.cloSoftwareVersionSchema;
                          this.startConfigurationData["softwareVerSchema"] =
                            this.softwareVersionSchema;
                          this.startConfigurationData["mtpSoftVer"] =
                            this.mtpSoftwareVersionSchema;
                          this.startConfigurationData["dynadimmerSoftVer"] =
                            this.dynadimmerSoftwareVersionSchema;
                          this.startConfigurationData[
                            "dcemergencySoftVer"
                          ] = this.dcemergencySoftwareVersionSchema;
                          this.startConfigurationData["ampdimSoftVer"] =
                            this.ampdimSoftwareVersionSchema;
                          this.startConfigurationData["lineswitchSoftVer"] =
                            this.lineswitchSoftwareVersionSchema;
                          this.startConfigurationData["owpSoftVer"] =
                            this.owpSoftwareVersionSchema;
                          this.startConfigurationData["codedmainsSoftVer"] =
                            this.codedmainsSoftwareVersionSchema;
                          this.startConfigurationData["dalipsuSoftVer"] =
                            this.dalipsuSoftwareVersionSchema;
                          this.startConfigurationData["dali102AddressingSoftVer"] =
                            this.daliaddressing102SoftwareVersionSchema;
                          this.startConfigurationData["dali102and207ConfigSoftVer"] =
                            this.dali102and207ConfigurationSoftwareVersionSchema;
                          this.startConfigurationData["auxSoftVer"] =
                            this.auxSoftwareVersionSchema;
                          this.startConfigurationData["lsiSoftVer"] =
                            this.lsiSoftwareVersionSchema;
                          this.startConfigurationData["aocmultichannelSoftVer"] =
                            this.aocmultichannelSoftwareVersionSchema;
                          this.startConfigurationData["otpSoftVer"] =
                            this.otpSoftwareVersionSchema;
                          this.startConfigurationData["dscSoftVer"] =
                            this.dscSoftwareVersionSchema;
                          this.startConfigurationData["lowmainslockSoftVer"] =
                            this.lowmainslockSoftwareVersionSchema;
                          this.startConfigurationData[
                            "dimminginterfaceSoftVer"
                          ] = this.dimminginterfaceSoftwareVersionSchema;
                          this.startConfigurationData[
                            "multiconfigSoftVer"
                          ] = this.multiconfigSoftWareVersionSchema;
                          this.startConfigurationData["device12nc"] =
                            deviceArg.device12nc;
                          this.startConfigurationData["feature12Nc"] =
                            feature12Nc;

                          // Preserve existing resp object from ConfigurationData or SaveSetData
                          const existingConfigData = this.appState.getConfigurationData();
                          const existingSaveSetData = this.appState.getSaveSetData();
                          if (existingConfigData && existingConfigData["resp"]) {
                            this.startConfigurationData["resp"] = existingConfigData["resp"];
                          } else if (existingSaveSetData && existingSaveSetData["resp"]) {
                            this.startConfigurationData["resp"] = existingSaveSetData["resp"];
                          } else {
                            // Initialize empty resp object to ensure it exists for feature configurations
                            this.startConfigurationData["resp"] = {};
                          }

                          this.appState.setConfigurationData(this.startConfigurationData);
                          // Create deep copy for SaveSetData
                          const saveDataCopy = JSON.parse(JSON.stringify(this.startConfigurationData));
                          this.appState.setSaveSetData(saveDataCopy);
                          this.appState.setSaveSetData1(saveDataCopy);
                          this.availFeat.setConfigurationData(
                            this.startConfigurationData
                          );
                          this.loading = false;
                          const mode = this.appState.getStoreConfigMode() || {};
                          if (
                            mode["storeConfigModeCheck"] &&
                            (mode["storeConfigModeData"] === "Standard" ||
                              mode["storeConfigModeData"] === "quickConfig")
                          ) {
                            this.uiSignals.sendModes("Standard");
                          } else {
                            this.uiSignals.sendModes("Advanced");
                          }
                          this.appState.removeDeviceVersion();
                          this.activeModal.close();
                          this.dimmingInterfaceSvc.sendDimmingCheckValidation("");
                          this.appState.setFromDeviceList("true");
                          this.route.navigate(["/featureLanding"]);
                          const configurationData = this.appState.getConfigurationData();
                          const dataSet = [];
                          for (
                            let i = 0;
                            i < configurationData.feature12Nc.length;
                            i++
                          ) {
                            dataSet.push({
                              name: configurationData.feature12Nc[i].slice(
                                0,
                                -1
                              ),
                              available: "true",
                            });
                          }
                          // let currentUser = JSON.parse(
                          //   localStorage.getItem("currentUser")
                          // );
                          // var decodedObj: LegacyAny = jwt_decode(
                          //   JSON.stringify(currentUser)
                          // );
                          // this._dataLayerService.logUserDetails({
                          //   UserId: localStorage.getItem("UserId"),
                          //   companyId: decodedObj.company["companyId"],
                          //   companyName: decodedObj.company["companyName"],
                          //   userRole: decodedObj.role,
                          // });
                          this._dataLayerService.setSelectedDeviceInfo({
                            event: "featureAvailable",
                            "12NC": configurationData.device12nc,
                            features: dataSet,
                          });
                        },
                        (error) => {
                          this.loading = false;
                          const modalRef = this.modalService.open(
                            ErrorComponent,
                            {
                              keyboard: false,
                              centered: true,
                              windowClass: "error-style, error-style1",
                              backdrop: 'static'
                            }
                          );
                          modalRef.componentInstance.errorName =
                            error["message"];
                          modalRef.componentInstance.errorDescription =
                            error["description"];
                        }
                      );
                //   }
                // });
            } else {
              this.activeModal.close();
              this.route.navigate(["/featureNonSupported"]);
            }
          });
      //   }
      // });
  }

  schemalistApi(device12nc, deviceSoftwareVersion) {
    return this.httpClient.getSupportedSchemaList(
      this.envScehmaLIstApi,
      device12nc,
      deviceSoftwareVersion
    );
  }

  confirming() {
    this.activeModal.close();

    // Preserve existing resp object from ConfigurationData or SaveSetData
    const existingConfigData = this.appState.getConfigurationData();
    const existingSaveSetData = this.appState.getSaveSetData();
    if (existingConfigData && existingConfigData["resp"] && !this.device["resp"]) {
      this.device["resp"] = existingConfigData["resp"];
    } else if (existingSaveSetData && existingSaveSetData["resp"] && !this.device["resp"]) {
      this.device["resp"] = existingSaveSetData["resp"];
    } else if (!this.device["resp"]) {
      // Initialize empty resp object to ensure it exists for feature configurations
      this.device["resp"] = {};
    }

    this.appState.setConfigurationData(this.device);
    // Create deep copy for SaveSetData
    const saveDataCopy = JSON.parse(JSON.stringify(this.device));
    this.appState.setSaveSetData(saveDataCopy);
    this.appState.setSaveSetData1(saveDataCopy);
    this.storeConfigData = this.appState.getModes();
    this.appState.setCloseConfigureModal(true);
    this.newConfigID();
  }

  callConfigdata() {
    this.activeModal.close();
    this.availFeat.sentdirectlyFeature("success");
    // setTimeout(()=>{
    //  this.isPageRefresh();
    // },5000);
  }

  newConfigID() {
    // this.service.getEnvValue();
    // this.service.getEnvData
    //   .pipe(takeUntil(this.unsubscribe))
    //   .subscribe((url) => {
    //     if (url.length) {
          const compareFirmware = this.appState.getCompareFirmwareNoLatest();
          if (compareFirmware) {
            this.softwareVersion1 = compareFirmware;
            if (this.softwareVersion1.length > 3) {
              this.softwareVersion1 = this.softwareVersion1.slice(0, -2);
            }
          }
          this.unsubscribe.next(undefined);
          this.envStartConfigURL = this.envHostName;
          const arrayString = this.appState.getConfigurationData();
          const a = arrayString;
          const mockDevice = {
            device12nc: this.device.device12nc,
            deviceName: this.device.deviceName,
            softwareVersion: this.softwareVersion1,
          };
          this.httpClient
            .getStartConfiguration(mockDevice, this.envStartConfigURL)
            .subscribe(
              (data) => {
                let configurationID;
                const deviceFullInfo = this.appState.getReaderDeviceFullInfo();
                if (deviceFullInfo != null) {
                  this.appState.setNFCProtocol(deviceFullInfo[0].configurationInterface);
                }
                a["configurationID"] = data["configurationID"];
                if (this.softwareVersion1.length > 3) {
                  a["softwareVersion"] = this.softwareVersion1.slice(0, -2);
                }
                this.appState.setNormalFlow(true);
                this.appState.setConfigurationData(a);
                // Create deep copy for SaveSetData
                const saveDataCopy = JSON.parse(JSON.stringify(a));
                this.appState.setSaveSetData(saveDataCopy);
                this.appState.setSaveSetData1(saveDataCopy);
                this.appState.setSaveReadValue(null);
                this.isPageRefresh();
              },
              (err) => {
                this.loading = false;
                const modalRef = this.modalService.open(ErrorComponent, {
                  keyboard: false,
                  centered: true,
                  windowClass: "error-style, error-style1",
                  backdrop: 'static'
                });
                modalRef.componentInstance.errorName = err["message"];
                modalRef.componentInstance.errorDescription =
                  err["description"];
                //alert(error["description"]);
              }
            );
      //   }
      // });
  }
  remove() {
    // let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    // var decodedObj: LegacyAny = jwt_decode(JSON.stringify(currentUser));
    // this._dataLayerService.logUserDetails({
    //   UserId: localStorage.getItem("UserId"),
    //   companyId: decodedObj.company["companyId"],
    //   companyName: decodedObj.company["companyName"],
    //   userRole: decodedObj.role,
    // });
    this._dataLayerService.resetSetSelectedDeviceInfo();
  }
  isPageRefresh() {
    window.location.reload();
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.uiSignals.callConfigMethod("");
  }

  otherDevice() {
    // Edit Device functionality removed - this method is now a no-op
    this.uiSignals.disableBtn("confirm");
  }
}
